<div class="performance-cell">
  <ng-container *ngIf="performanceData; else noPerformanceData">
    <div class="performance-item" *ngFor="let row of metricRows">
      <svg
        class="performance-icon"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ng-container [ngSwitch]="row.icon">
          <ng-container *ngSwitchCase="'impressions'">
            <path
              d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="12"
              cy="12"
              r="3"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </ng-container>
          <ng-container *ngSwitchCase="'clicks'">
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="12"
              cy="12"
              r="6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
          </ng-container>
          <ng-container *ngSwitchCase="'conversions'">
            <path
              d="M20 6L9 17l-5-5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </ng-container>
          <ng-container *ngSwitchCase="'revenue'">
            <line
              x1="12"
              y1="1"
              x2="12"
              y2="23"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </ng-container>
        </ng-container>
      </svg>
      <span class="p5">{{ row.label }}</span>
    </div>
  </ng-container>
  <ng-template #noPerformanceData>
    <span class="p5">No performance data available</span>
  </ng-template>
</div>
